export const STRING_TYPE = 'string';
export const SLICE_METADATA = 28;

export enum UserRole {
  visitor,
  interviewee,
  interviewer,
  admin,
}
export enum PROGRAMMING_LANGUAGES {
  c,
  cpp,
  python,
  java,
  javascript,
  other,
}
export enum COMPANIES {
  amazon,
  facebook,
  github,
  google,
  microsoft,
  netflix,
  twitter,
}
export enum SCHEDULE_API_MAP {
  position,
  job,
  awaiting,
  language,
  company,
}

/* TODO: See if we are going to put the complete number */
export const UNIVERSITIES: { [string: string]: string } = {
  IPN: 'IPN',
  UNAM: 'UNAM',
  CIMAT: 'CIMAT',
  Other: 'other',
};
export const JOBS: { [string: string]: string } = {
  'Software Engineer': 'SE',
  'Machine Learning': 'ML',
  'Reliability Engineering': 'RE',
  'Data Science': 'DS',
};
export const POSITIONS: { [string: string]: string } = {
  Internship: 'Intern',
  'Full Time': 'FTE',
  'Explore/STEP': 'STEP',
};

export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
